import React, { useCallback, useEffect, useState } from 'react'
import { Breadcrumb, MenuAccount } from '../../../components/Main'
import { useTranslation } from 'react-i18next'
import InteractorShippingHeaderSearch from '../../../interactors/transaction/shipping/InteractorShippingHeaderSearch'
import { useSelector } from 'react-redux'
import WideCardConfirmationShipping from '../../../components/widecard/WideCardConfirmationShipping'
import InteractorCsvShipping from '../../../interactors/csv/InteractorCsvShipping'
import { defaultValueDownloadCSV, maxLimitExport } from '../../../constant/global/validation'

const ConfirmationShippingIndex = () => {
  const { t } = useTranslation()
  const { shippingHeaderSearch } = InteractorShippingHeaderSearch()
  const { csvShipping } = InteractorCsvShipping()
  const { account } = useSelector((state) => state.account)
  const [loading, setLoading] = useState(true)
  const [loadingCSV, setLoadingCSV] = useState(false)
  const [datacard, setDatacard] = useState([])
  const [payload, setPayload] = useState({
    page: 1,
    limit: 10,
    keywords: {
      text_search: '',
      uid: '',
      transaction_uid: '',
      account_uid: account?.uid,
      status: '',
      store_uid: '',
    },
  })
  const [download, setDownload] = useState(defaultValueDownloadCSV)

  const handleResponse = useCallback((data) => {
    setDatacard(data)
    // csvShipping(data.items, setDownload)
  }, [])

  const handleResponseCSV = useCallback(
    (data) => {
      csvShipping(data?.items, setDownload)
    },
    [csvShipping],
  )

  const handleFilter = (row) => {
    setPayload(row)
    setDatacard([])
    setLoading(true)
  }
  useEffect(() => {
    if (loading) {
      shippingHeaderSearch(payload, handleResponse, setLoading)
    }
  }, [shippingHeaderSearch, handleResponse, loading, payload])

  const getDataConfirmShipping = () => {
    let payloadCsv = { ...payload }
    payloadCsv.limit = maxLimitExport
    setLoadingCSV(true)
    shippingHeaderSearch(payloadCsv, handleResponseCSV, setLoadingCSV)
  }

  return (
    <>
      <Breadcrumb title={t('menu.confirmation_shipping')} className="mb-4" />
      <div className="container">
        <div className="row mb-8">
          <MenuAccount />
          <div className="col-xl-9 col-wd-9gdot5">
            <div className="flex-center-between mt-2 mt-0-lg">
              <h3 className="font-size-20 font-size-20-lg font-weight-bold mb-0">
                {t('menu.confirmation_shipping')}
              </h3>
            </div>
            <hr />
            <WideCardConfirmationShipping
              loading={loading}
              datacard={datacard}
              payload={payload}
              handleFilter={handleFilter}
              download={download}
              setDownload={setDownload}
              getDataConfirmShipping={getDataConfirmShipping}
              loadingCSV={loadingCSV}
            />
          </div>
        </div>
      </div>
    </>
  )
}

export default ConfirmationShippingIndex
